/*
 * @Author: yangxu
 * @Description:
 * @Date: 2023-03-17 15:14:41
 * @LastEditTime: 2023-03-17 15:14:55
 * @FilePath: /js_partner-admin-v2_src/src/utils/Jsonp.js
 */
import orginJSONP from 'jsonp';

export default function jsonp(url, data, option) {
	url += (url.indexOf('?') < 0 ? '?' : '&') + param(data);
	return new Promise((resolve, reject) => {
		orginJSONP(url, option, (err, data) => {
			if (!err) {
				resolve(data);
			} else {
				reject(err);
			}
		});
	});
}
function param(data) {
	let url = '';
	for (var k in data) {
		let values = data[k] !== undefined ? data[k] : '';
		url += `&${k}=${encodeURIComponent(values)}`;
	}
	return url ? url.substring(1) : '';
}
